export default __webpack_public_path__ + "static/media/right-icon.7010ba8b.svg";